<div (clickOutside)=" hideSearchResult()">
  <div [class.noborder]="!showTemplateFolder" class="searchsection">
    <div class="searchinput-wrapper">
      <div class="searchinput">
        <input type="search"
               [placeholder]=" (isTemplateFolder ? '_search_from_template_folder_' : '_create_from_template_') | translate "
               #searchBox
               (focusin)="onInputClicked()"
               (keyup.enter)="search(searchBox.value)"
               class="search-input"
        />
        <div *ngIf="searchString" (click)="closeSearch()" class="close-search">
          <ion-icon name="close-circle-outline"></ion-icon>
        </div>
      </div>
      <div style="display: flex;align-items: center">
        <div (click)="search(searchBox.value)" class="searchicon">
          <ion-icon name="search-outline"></ion-icon>
        </div>
        <div *ngIf="showTemplateFolder" (click)="navigatetoTemplate()" style="margin-left: 10px" class="templateicon">
          <ion-icon name="folder"></ion-icon>
        </div>
      </div>
    </div>


    <!--search ressult-->

    <div *ngIf="isSearchClicked && loading">
      <app-search-template-skeleton></app-search-template-skeleton>
    </div>


    <div *ngIf="isSearchClicked && !loading"  class="dropdown-wrapper">
      <div class="template-list">
        <div style="border-bottom: 1px solid #C5C5C7">
          <div class="result-title-content">
            <p>{{resultTemplates.length}} results</p>
            <ion-icon name="filter-outline" style="font-size: 24px;cursor: pointer"
                      (click)="toggleselectType()"></ion-icon>
          </div>
        </div>

        <div *ngIf="resultTemplates.length === 0 ">
          <p class="empty-data">{{'_no_templates_found_' | translate}}</p>
        </div>

        <div *ngIf="resultTemplates.length > 0">
          <div *ngIf="showOfferOption" class="current-section">
            <p class="current-in-view">Currently in view:</p>
            <div class="offer-container">
              <div class="offer-type" (click)="toggleType('jatak')">
                <ion-icon *ngIf="!isJatakClicked " class="check-icon" name="square-outline"></ion-icon>
                <ion-icon *ngIf="isJatakClicked " class="check-icon" name="checkbox"></ion-icon>
                <p class="offer-type-text">JA TAK</p>
              </div>
              <div class="offer-type" (click)="toggleType('post')">
                <ion-icon *ngIf="!isRegularPostCliked " class="check-icon" name="square-outline"></ion-icon>
                <ion-icon *ngIf="isRegularPostCliked " class="check-icon" name="checkbox"></ion-icon>
                <p class="offer-type-text">{{ '_regular_posts_' | translate }}</p>
              </div>

              <div class="offer-type" (click)="toggleType('competition')">
                <ion-icon *ngIf="!isCompetitionClicked " class="check-icon" name="square-outline"></ion-icon>
                <ion-icon *ngIf="isCompetitionClicked " class="check-icon" name="checkbox"></ion-icon>
                <p class="offer-type-text">{{ '_competition_' | translate }}</p>
              </div>
                <div class="offer-type" (click)="toggleType('spinning_wheel')">
                    <ion-icon *ngIf="!isWheelsClicked " class="check-icon" name="square-outline"></ion-icon>
                    <ion-icon *ngIf="isWheelsClicked " class="check-icon" name="checkbox"></ion-icon>
                    <p class="offer-type-text">{{ '_spinning_wheel_' | translate }}</p>
                </div>

                <div class="offer-type" (click)="toggleType('scratch_card')">
                    <ion-icon *ngIf="!isCardClicked " class="check-icon" name="square-outline"></ion-icon>
                    <ion-icon *ngIf="isCardClicked " class="check-icon" name="checkbox"></ion-icon>
                    <p class="offer-type-text">{{ '_scratch_card_' | translate }}</p>
                </div>
            </div>
          </div>
          <div *ngFor="let resultTemplate of resultTemplates;let last= last">
            <div class="result-list" (click)="onTemplateSelect(resultTemplate)">
              <div style="display: flex">
                <img
                  [src]="resultTemplate.image[0]['thumbnail']"
                  class="result-img"
                />
                <div class="result-content">
                  <span class="result-type" *ngIf="resultTemplate.type === 'jatak'">JA TAK</span>
                  <span class="result-type"
                        *ngIf="resultTemplate.type === 'post'">{{ '_regular_posts_' | translate }}</span>
                  <span class="result-type"
                        *ngIf="resultTemplate.type === 'competition'">{{ '_competition_' | translate }}</span>
                  <span class="result-type"
                        *ngIf="resultTemplate.type === 'spinning_wheel'">{{ '_spinning_wheel_' | translate }}</span>
                  <span class="result-type"
                        *ngIf="resultTemplate.type === 'scratch_card'">{{ '_scratch_card_' | translate }}</span>
                  <span
                    class="result-type"
                    *ngIf="resultTemplate.type === 'products'">Product</span>
                  <div>
                    <p class="result-subtitle">{{resultTemplate.title}}</p>
                  </div>
                </div>
              </div>
              <div style="width: 24px">
                <ion-icon name="chevron-forward-outline" class="result-right-icon"></ion-icon>
              </div>
            </div>
            <div *ngIf="!last" class="hr"></div>
          </div>
        </div>

        <div *ngIf="(resultTemplatesPage > templatePage) && resultTemplates.length > 0">
          <div (click)="loadMore($event)" class="loadmoreBtn">
            <p>{{"_load_more_" |translate}}</p>
          </div>
        </div>


      </div>
    </div>

  </div>
</div>
